<template>
  <div>
    <OptionsContainer />
  </div>
</template>

<script>
import OptionsContainer from "@/components/store/webStore/options/container/OptionsContainer.vue";
export default {
  components: {
    OptionsContainer
  }
};
</script>
